module.exports = __webpack_public_path__ + "img/herb-tarragon-350x184.da9ff418.jpg";